import { state } from '../state.js';
import { $ } from '../utils/dom.js';

let onChange = null;

export function bindFilters(renderFn) {
  onChange = renderFn;

  $('fDesde').oninput = (e) => { state.filters.desde = e.target.value; applyFilters(); };
  $('fHasta').oninput = (e) => { state.filters.hasta = e.target.value; applyFilters(); };
  $('fSearch').oninput = (e) => { state.filters.search = e.target.value; applyFilters(); };
  $('fMetaStatus').oninput = (e) => { state.filters.metaStatus = e.target.value; applyFilters(); };
  $('fCtwa').oninput = (e) => { state.filters.ctwa = e.target.value; applyFilters(); };
  $('fMetaMode').oninput = (e) => { state.filters.metaMode = e.target.value; applyFilters(); };
  $('clearBtn').onclick = () => {
    state.filters = {
      desde: '',
      hasta: '',
      search: '',
      statuses: new Set(),
      metaStatus: '',
      ctwa: '',
      metaMode: '',
    };
    $('fDesde').value = '';
    $('fHasta').value = '';
    $('fSearch').value = '';
    $('fMetaStatus').value = '';
    $('fCtwa').value = '';
    $('fMetaMode').value = '';
    buildStatusChips();
    applyFilters();
  };
}

export function buildStatusChips() {
  const set = new Set();
  state.rows.forEach((r) => r.STATUS && set.add(r.STATUS));
  const cont = $('statusChips');
  cont.innerHTML = '';
  if (state.filters.statuses.size === 0) {
    set.forEach((s) => state.filters.statuses.add(s));
  }
  [...set].sort().forEach((s) => {
    const el = document.createElement('span');
    el.className = 'chip' + (state.filters.statuses.has(s) ? ' active' : '');
    el.textContent = s;
    el.onclick = () => {
      if (state.filters.statuses.has(s)) state.filters.statuses.delete(s);
      else state.filters.statuses.add(s);
      el.classList.toggle('active');
      applyFilters();
    };
    cont.appendChild(el);
  });
}

export function applyFilters(keepPage) {
  const { desde, hasta, search, statuses, metaStatus, ctwa, metaMode } = state.filters;
  const dDesde = desde ? new Date(desde + 'T00:00:00') : null;
  const dHasta = hasta ? new Date(hasta + 'T23:59:59') : null;
  const q = search.trim().toLowerCase();

  state.filtered = state.rows.filter((r) => {
    if (dDesde && (!r.FECHA || r.FECHA < dDesde)) return false;
    if (dHasta && (!r.FECHA || r.FECHA > dHasta)) return false;
    if (statuses.size && !statuses.has(r.STATUS)) return false;
    if (metaStatus && r.META_STATUS !== metaStatus) return false;
    if (ctwa === 'present' && r.CTWA_PRESENT !== true) return false;
    if (ctwa === 'missing' && r.CTWA_PRESENT !== false) return false;
    if (metaMode && r.META_MODE !== metaMode) return false;
    if (q) {
      const hay = [r.NOMBRE, r.EMAIL, r.NUMERO, r.AD_ID, r.POST_ID, r.BANCO, r.STATUS, r.SHEET_NAME].join(' ').toLowerCase();
      if (!hay.includes(q)) return false;
    }
    return true;
  });
  if (!keepPage) state.page = 1;
  if (onChange) onChange();
}
